import { queryConfigListForCompany } from '@/services/user'

export const removeDuplicatesBySelectName = (array: any) => {
    const uniqueObjects = []
    const selectNameSet = new Set()

    for (const obj of array) {
        if (!selectNameSet.has(obj?.selectName)) {
            uniqueObjects.push(obj)
            selectNameSet.add(obj?.selectName)
        }
    }

    return uniqueObjects
}
// 商家维度快捷查询, 会有并发问题, 保存前要重新校验数据
export const beforeSaveSelect = async (configKey: string, configData: any, oldConfigData: any, override) => {
    if (override) {
        return {
            filters: configData?.filters ?? []
        }
    }

    const { success, data } = await queryConfigListForCompany({
        configKey
    })

    if (!success) {
        return configData
    }

    const oldlist = removeDuplicatesBySelectName([...(oldConfigData?.[configKey]?.filters ?? [])])
    const savelist = configData?.filters ?? []

    const itemsToAdd = savelist.filter(itemB => !oldlist.some(itemA => itemA.selectName === itemB.selectName))
    const itemsToDelete = oldlist.filter(itemA => !savelist.some(itemB => itemB.selectName === itemA.selectName))

    const newlist = data?.[configKey]?.filters ?? []
    let updatedList = [...newlist]

    itemsToDelete.forEach(itemToDelete => {
        const indexToDelete = updatedList.findIndex(item => item.selectName === itemToDelete.selectName)
        if (indexToDelete !== -1) {
            updatedList.splice(indexToDelete, 1)
        }
    })

    return {
        filters: [...itemsToAdd, ...updatedList]
    }
}
